module.exports = __webpack_public_path__ + "media/images/details__prizeBox__event__second-25fab01b1f3841f941fea768b2d77869.png";